import React from 'react'
import Logo from './Logo'
import Icon from './Icon'
import PropTypes from 'prop-types'

const BlockQuote = ({ htmlText }) => {
  return (
    <div className="relative py-3 px-4">
      <div className="absolute inset-0 bg-gradient-to-r from-light-blue-500 to-blue-700 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:rotate-6 sm:rounded-3xl" />
      <div className="absolute inset-0 bg-gradient-to-r from-pink-500 to-rose-500 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl" />
      <blockquote className="relative bg-white rounded-3xl shadow-lg">
        <div className="rounded-t-lg px-6 py-8 sm:px-10 sm:pt-10 sm:pb-8">
          <Logo htmlClass={`h-12 w-auto mx-auto`} textColor={`#0f172a`} />
          <div className="relative text-lg text-gray-700 font-medium mt-8">
            <svg
              className="absolute top-0 left-0 transform -translate-x-4 -translate-y-8 h-20 w-20 text-rose-200 opacity-50"
              fill="currentColor"
              viewBox="0 0 32 32"
              aria-hidden="true"
            >
              <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
            </svg>
            <p
              className="relative"
              dangerouslySetInnerHTML={{
                __html: htmlText,
              }}
            />
          </div>
        </div>
        <cite className="relative flex items-center sm:items-start bg-rose-600 rounded-b-3xl not-italic py-5 px-6 sm:py-5 sm:pl-12 sm:pr-10 sm:mt-10">
          <div className="relative rounded-full border-2 border-white sm:absolute sm:top-0 sm:transform sm:-translate-y-1/2">
            <Icon htmlClass={`w-12 h-12 sm:w-20 sm:h-20 rounded-full bg-white`} />
          </div>
          <div className="relative ml-4 text-rose-100 font-semibold leading-6 sm:ml-24 sm:pl-1">
            <p className="text-white font-semibold sm:inline">Gubelinlab,</p>
            {` `}
            <p className="sm:inline">Situs Tips Judi Online Indonesia</p>
          </div>
        </cite>
      </blockquote>
    </div>
  )
}

BlockQuote.prototype = {
  htmlText: PropTypes.string,
}

export default BlockQuote
